<b3-drawer
  [open]="isOpen"
  size="sm"
  overlay
  (b3-close)="close()"
  (b3-back)="close()">
  <b3-drawer-header
    heading="Filtrar"
    show-back
    back-aria-label="Fechar filtros">
  </b3-drawer-header>

  <b3-drawer-body>
    <form class="filter-form" [formGroup]="formFilter">
      <ng-container *ngFor="let resetKey of [datepickerResetKey]; trackBy: trackDatepickerResetKey">
        <div class="filter-field">
          <b3-datepicker
            inputId="positionDate"
            label="Data da posição"
            formControlName="positionDate"
            background="grey"
            placeholder="DD/MM/AAAA"
            locale="pt-BR"
            (b3-change)="onPositionDateChange($event)">
          </b3-datepicker>
        </div>
      </ng-container>

      <div class="filter-field">
        <b3-input-text
          formControlName="financialInstrumentCode"
          inputId="filterCarbonCreditCode"
          label="Código do Instrumento Financeiro"
          background="grey"
          placeholder="Codigo IF">
        </b3-input-text>
      </div>

      <div class="filter-field">
        <b3-input-text
          formControlName="projectId"
          inputId="filterProjectId"
          label="ID do Projeto"
          background="grey"
          placeholder="ID">
        </b3-input-text>
      </div>

      <div class="filter-field">
        <b3-input-text
          formControlName="holderAccount"
          inputId="filterHolderAccount"
          label="Conta detentor"
          background="grey"
          mask="account"
          placeholder="00000.00-0">
        </b3-input-text>
      </div>

      <div class="filter-actions">
        <b3-button
          type="button"
          variant="ghost"
          tone="default"
          size="lg"
          class="filter-actions__btn"
          (b3-click)="cleanForm()">
          <b3-icon name="backspace" size="sm"></b3-icon>
          Limpar
        </b3-button>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          size="lg"
          class="filter-actions__btn"
          (b3-click)="filter()">
          <b3-icon name="filter_list" size="sm" tone="on-brand"></b3-icon>
          Filtrar
        </b3-button>
      </div>
    </form>
  </b3-drawer-body>
</b3-drawer>
